import { TimeInputWUT } from '@wix/form-fields/viewer-wut';

export default TimeInputWUT;
